module.exports = __webpack_public_path__ + "assets/img/bg1.8a4aba1a.gif";